import React, { useState } from 'react';
import classnames from 'classnames';
import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Badge,
} from 'reactstrap';

import { useAdminUser } from '../../contexts';
import AccountProfile from './AccountProfile';
import AccountSettings from './AccountSettings';
import AccountTwoFactor from './AccountTwoFactor';

const TABS = [
  { id: 'profile', label: 'Profile' },
  { id: 'settings', label: 'Settings' },
  { id: 'two-factor', label: '2-Factor Authentication' },
];

// Personal hub for the logged-in user (Profile + Settings). Reachable only via
// the Header dropdown (the route is `hidden`, so it never appears in the
// sidebar). Supports deep-linking to a tab via ?tab=<id>.
const AccountHub = ({ location }) => {
  const { administrator } = useAdminUser();

  const params = new URLSearchParams(location.search);
  const requested = params.get('tab');
  const valid = TABS.some((t) => t.id === requested);
  const [activeTab, setActiveTab] = useState(valid ? requested : 'profile');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const displayName =
    (administrator && administrator.user && administrator.user.name) ||
    (administrator && administrator.user && administrator.user.email) ||
    'Signed in';

  const role = administrator && administrator.roles;

  return (
    <div className="container-fluid">
      <Row className="mt-4">
        <Col xs={12} md={12}>
          <Row className="align-contents-center">
            <Col xs={12} md={6}>
              <h4>My Account</h4>
              <p className="category">
                {displayName}
                {role ? (
                  <Badge color="info" className="ml-2">
                    {role}
                  </Badge>
                ) : null}
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Nav tabs>
                    {TABS.map((tab) => (
                      <NavItem key={tab.id}>
                        <NavLink
                          className={classnames({
                            active: activeTab === tab.id,
                          })}
                          onClick={() => toggle(tab.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          {tab.label}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <br />

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="profile">
                      {activeTab === 'profile' && <AccountProfile />}
                    </TabPane>
                    <TabPane tabId="settings">
                      {activeTab === 'settings' && <AccountSettings />}
                    </TabPane>
                    <TabPane tabId="two-factor">
                      {activeTab === 'two-factor' && <AccountTwoFactor />}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default AccountHub;
